<template>
<div class="c_upgrade_w" :class="{'c_upgrade_w_show': showUpgrade}"  @click.stop="hideUpgrade">
  <div class="c_upgrade" @click.stop>
    <div class=""></div>
    <img :src="require('@/assets/vip.png')" :srcset="`${require('@/assets/vip@2x.png')} 2x`" class="vipicon" />
    <div class="text_1">
      {{$t('upgrade.tip_1')}}
    </div>
    <div class="text_2">
      {{$t('upgrade.tip_2')}}
    </div>
    <a href="/pricing" class="btn"  >{{$t('upgrade.btn')}}</a>
  </div>
</div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      showUpgrade: state => state.showUpgrade,
    }),
  },
  methods: {
    ...mapMutations(['hideUpgrade']),
    go() {
      this.$router.push({
        name: 'subscribe',
      })
      this.hideUpgrade()
    },
  },
}
</script>

<style lang="scss" scoped>
.c_upgrade_w{
  height: 100%;
  width: 100%;
  background: rgba(0,0,0,0.7);
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  opacity: 0;
  visibility: hidden;
  transition: 0.2s ease;
  z-index: 301;
}
.c_upgrade_w_show{
  opacity: 1;
  visibility: visible;
  .c_upgrade{
    opacity: 1;
    visibility: visible;
    transform: translate3d(-50%, -50%, 0);
  }
}
.c_upgrade{
  opacity: 0;
  visibility: hidden;
  transition: 0.2s ease;
  background-image: linear-gradient(180deg, #FFFFFF 0%, #F4F4F4 100%, #FFFFFF 100%);
  border: 1px solid #A8A8A8;
  border-radius: 8px;
  height: 240px;
  width: 360px;
  border-radius: 8px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate3d(-50%, -40%, 0);
  z-index: 1;
  .vipicon{
    position: absolute;
    z-index: 2;
    left: 50%;
    top: 0;
    height: 77px;
    width: 78px;
    transform: translate(-50%, -50%);
  }
  .text_1{
    line-height: 32px;
    text-align: center;
    font-size: 24px;
    color: #545454;
    text-align: center;
    padding-top: 44px;
    font-weight: bold;
    padding-bottom: 14px;
  }
  .text_2{
    font-size: 14px;
    color: #B9B9B9;
    text-align: center;
    line-height: 20px;
    padding-bottom: 22px;
    width: 200px;
    margin: 0 auto;
  }
  .btn{
    display: block;
    background: #2E7FFF;
    box-shadow: 0 0 5px 0 rgba(91,91,91,0.50);
    border-radius: 999px;
    font-size: 14px;
    color: #FFFFFF;
    text-align: center;
    height: 40px;
    line-height: 40px;
    border-radius: 999px;
    width: 178px;
    margin: 0 auto;
    text-decoration: none;
    padding: 0;
    cursor: pointer;
    &:hover{
      background-image: linear-gradient(180deg, #2772E9 0%, #216BE0 100%);
    }
  }
}
</style>
